export const BASE_TITLE = 'Varisht';

export const CONSTANTS = {
  title: {
    login: `Login - ${BASE_TITLE}`,
    dashboard: `Dashboard - ${BASE_TITLE}`,
    students: `Students - ${BASE_TITLE}`,
    staff: `Staff - ${BASE_TITLE}`,
    academics: `Academics - ${BASE_TITLE}`,
    communications: `Communications - ${BASE_TITLE}`,
    finance: `Finance - ${BASE_TITLE}`,
    administration: `Administration - ${BASE_TITLE}`,
    analytics: `Analytics - ${BASE_TITLE}`,
    settings: `Settings - ${BASE_TITLE}`,
    inventory: `Inventory - ${BASE_TITLE}`,
    users: `Users - ${BASE_TITLE}`,
    profile: `Profile - ${BASE_TITLE}`,
    studentDetails: `Student Details - ${BASE_TITLE}`,
  },
  dropdownDefaultKey: 'select',
  dropdownDefaultValue: 'Select a value',
};
